import React from 'react';
import SettlementManagement from '../payrollsheet/tabs/SettlementManagement';

const SettlementManagementPage = () => {
  return <SettlementManagement />;
};

export default SettlementManagementPage;

